import { Box, ColorOptions, Form, Icon, ModBox, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../../data/store'
import { renderActionButtons } from './ActionButtons'
import { beneficiaryTypesList, formAddSingleBeneficiary } from './form'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'

const SingleBeneficiary = ({ onClosePress, mid }: any) => {
  const { addSingleBeneficiary, addNewBeneficiaryType } = useStores((store) => ({
    addSingleBeneficiary: store?.beneficiaryOnboarding.addSingleBeneficiary,
    addNewBeneficiaryType: store?.beneficiaryOnboarding.addNewBeneficiaryType,
  }))

  const [addSingBeneficiaryReq, addSingleBeneficiaryHandler] = useLazyApiData(addSingleBeneficiary)

  useEffect(() => {
    if (addSingleBeneficiaryHandler?.state === 'fulfilled' || addSingleBeneficiaryHandler?.state === 'rejected') {
      onClosePress && onClosePress()
    }
  }, [addSingleBeneficiaryHandler?.state, onClosePress])

  const navigation = useNavigation()

  const [isAddAddressPressed, onAddAddressPressed] = useState(false)
  const [step, setStep] = useState(0)
  const [initValues, updateInitValues] = useState({
    name: '',
    phone: '',
    email: '',
    beneficiaryId: '',
    beneficiaryType: '',
    accountNumber: '',
    ifsc: '',
    upiVpa: '',
    cardNumber: '',
  })

  const onNextPress = () => {
    setStep((prev) => prev + 1)
  }

  const onBackPress = () => {
    setStep((prev) => prev - 1)
  }

  const onBeneficiaryTypeItemSelected = (item: any) => {
    console.log('SingleBeneficiary onBeneficiaryTypeItemSelected', item)
    if (!beneficiaryTypesList?.map((ben) => ben?.text).includes(item?.text ?? item?.value)) {
      addNewBeneficiaryType(mid, 'beneficiaryType', item)
    }
  }
  return (
    <ModBox w={'100%'} h={'100%'} alignItems={'center'} justifyContent={'center'}>
      <Box bg={'WHITE'} p={24} borderRadius={8}>
        <Box direction="row">
          <ModBox alignItems={'center'} marginTop={24} marginBottom={24}>
            <Box
              width={24}
              height={24}
              borderRadius={12}
              borderColor={'GREEN'}
              backgroundColor={'GREEN'}
              alignItems={'center'}
              justifyContent={'center'}>
              <Text fontFamily="jiotype-medium" color={'WHITE'} fontSize={14} title="1" />
            </Box>
            <Box w={2} h={step === 0 ? '85%' : '23%'} backgroundColor={'#E0E0E0' as ColorOptions} marginVertical={8} />
            <Box
              width={24}
              height={24}
              borderRadius={12}
              borderWidth={2}
              borderColor={step === 1 ? 'GREEN' : ('#E0E0E0' as ColorOptions)}
              backgroundColor={step === 1 ? 'GREEN' : 'WHITE'}
              alignItems={'center'}
              justifyContent={'center'}>
              <Text fontFamily="jiotype-medium" color={step === 1 ? 'WHITE' : 'BLACK_21'} fontSize={14} title="2" />
            </Box>
          </ModBox>
          <Box marginLeft={16}>
            <Box underlayColor={'TRANSPARENT'} testID="closePress" onPress={onClosePress} alignItems={'flex-end'}>
              <Icon id={'CLOSE'} color={'BLACK_21'} size={20} />
            </Box>
            <ModBox>
              <Form
                formData={formAddSingleBeneficiary(
                  true,
                  step,
                  initValues,
                  isAddAddressPressed,
                  onAddAddressPressed,
                  true,
                  onBeneficiaryTypeItemSelected,
                  beneficiaryTypesList,
                )}
                actionButtons={(props) =>
                  renderActionButtons(
                    props,
                    step,
                    addSingleBeneficiaryHandler?.state === 'pending',
                    onNextPress,
                    onBackPress,
                    addSingBeneficiaryReq,
                    mid,
                  )
                }
                container={DefaultFormContainer}
                initialValues={initValues}
              />
            </ModBox>
          </Box>
        </Box>
      </Box>
    </ModBox>
  )
}

export { SingleBeneficiary }
